import { InputTitle } from 'components/input/InputTitle';
import { Button, Spacing, TextInput, Typography } from 'enable-ui';

import { TitleLink } from '../styles';

import { PATH } from 'constants/path';

import { useForgotPasswordController } from '../core';

export const ForgotPasswordPage = () => {
  const { account, disabled, handleChange, handleSubmit, navigationTo, emailStatus } =
    useForgotPasswordController();

  return (
    <div>
      <Spacing spacing="4xl" placement="bottom" type="margin" style={{ textAlign: 'center' }}>
        <Typography
          variant="h4"
          weight={500}
          style={{
            fontSize: '26px',
            lineHeight: '36px',
            marginBottom: 12,
          }}
        >
          Forgot your password?
        </Typography>
        <Typography style={{ fontSize: '18px', lineHeight: '26px' }}>
          Enter your email address below and we'll send you a link to set new password for both of
          your web and mobile app account.
        </Typography>
      </Spacing>
      <Spacing spacing="4xl" placement="bottom" type="margin">
        <InputTitle title="Email" style={{ color: '#222222' }} />
        <TextInput
          name="account"
          value={account}
          onChange={handleChange}
          containerStyle={{
            maxWidth: 'auto',
          }}
          helperText={emailStatus.helperText}
          color={emailStatus.color}
        />
      </Spacing>

      <Spacing spacing="xl" placement="bottom" type="margin">
        <Button
          variant="contained"
          color="primary"
          type="submit"
          size="large"
          style={{
            width: '100%',
            fontSize: '18px',
            lineHeight: '26px',
            fontWeight: 600,
          }}
          disabled={disabled}
          onClick={() => handleSubmit()}
        >
          Continue
        </Button>
      </Spacing>
      <Spacing spacing="sm" placement="top" type="margin" style={{ textAlign: 'center' }}>
        <TitleLink onClick={() => navigationTo(PATH.LOGIN)}>Back to Log In</TitleLink>
      </Spacing>
    </div>
  );
};
